<template>
  <div>
    <div class="help_Info_right fr">
      <div class="help_Info_right_top fl">支付方式</div>
      <div class="help_Info_right_bootm shoppstep fl">
        <span class="help-title">支付方式有哪些？如何支付？</span>
        <dl>
          <dd>客户可通过转账、汇款等线下支付方式，将货款支付到我司对公账户，账户号码可咨询客服，线下转账金额与订单结算金额一定要保持一致。</dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pays"
};
</script>

<style>
</style>